<template>

    <main class="">

        <div class="bg-light py-5">

            <div class="container narrow-container text-center">

                <div class="mb-4">
                    <div class="row flex-column gap-4">
                        <div class="col">
                            <h1 class="display-4">{{ __('Punktestand') }}</h1>
                        </div>
                        <div class="col">
                            <div class="fw-bold">
                                Zahnarztpraxis Stepke
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bg-white mt-4 p-4">
                    <h2 class="text-secondary fw-light">{{ __('Punktestand') }}</h2>
                    <p>
                        Ihre gesammelten Punkte
                    </p>
                    <div>
                        <div class="display-4">
                            5.500
                            <!--{{ account.number_points | localizeNumber }}-->
                        </div>
                        <!--                    <div v-else>
                                                <i>
                        {{ __('Sie haben noch keine Punkte gesammelt') }}
                                                </i>
                                            </div>-->
                    </div>
                </div>

                <div class="bg-white mt-4 p-4">
                    <h2 class="text-secondary fw-light">{{ __('Transaktionen') }}</h2>
                    <p>
                        Für viele Aktionen im Marktplatz erhalten Sie Punkte. Ihre letzten Transaktionen können Sie hier einsehen.
                    </p>
                    <div>
                        <div class="border-bottom">
                            <div class="row align-items-center">
                                <div class="col-2">
                                    <div class="display-4">
                                        20
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div>
                                        Öffentliches Profil vervollständigt
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="text-end">
                                        10.02.2023
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom">
                            <div class="row align-items-center">
                                <div class="col-2">
                                    <div class="display-4">
                                        50
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div>
                                        Einkauf bei Dental Bauer
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="text-end">
                                        08.02.2023
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom">
                            <div class="row align-items-center">
                                <div class="col-2">
                                    <div class="display-4">
                                        30
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div>
                                        Einkauf bei Cherrymed
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="text-end">
                                        05.02.2023
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="border-bottom">
                            <div class="row align-items-center">
                                <div class="col-2">
                                    <div class="display-4">
                                        300
                                    </div>
                                </div>
                                <div class="col-8">
                                    <div>
                                        Einkauf bei 3M
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="text-end">
                                        01.02.2023
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <div class="py-5 text-center">
            <inertia-link :href="route('test.rewards')" class="btn btn-lg btn-outline-primary">
                {{ __('Alle Informationen zum Bonus-Program') }}
            </inertia-link>
        </div>

    </main>

</template>

<script>
    export default {
        props: [
        ],
        data() {
            return {
            }
        },
        components: {
        },
        methods: {
        },
    }
</script>